
import "./style.css";
import { useRef, useState, useEffect } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useTranslation } from "react-i18next";
import {
  businessRegister,
  resendEmailAccountVerification,
  checkEmailRegister
} from "../../../actions/auth";
import { withAlert, types } from "react-alert";
import { useLoading } from "../../../components/LoadingContext";
import { ArrowRightIcon } from "../../../components/icons";
import { validateForm, isValidEmail } from "./validation/validator";
import { optionsPronounce, businessData, businessTypeData } from "../../../utils/dataLists";
import MoUModal from "./_components/MoUModal";
import AccountInformation from "./_components/sections/AccountInformation";
import BusinessInformation from "./_components/sections/BusinessInformation";
import AuthorizedRepresentativeContacts from "./_components/sections/AuthorizedRepresentativeContacts";
import AdditionalEmail from "./_components/sections/AdditionalEmail";
import BillingInformation from "./_components/sections/BillingInformation";
import BusinessLicense from "./_components/sections/BusinessLicense";
import SuccessPage from "./_components/SuccessPage";
import { usePostalCodeLookup } from "../../../components/input/postal-code";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal, fadeUp, pressable } from "../../../components/motion";

// Each form block reveals as it scrolls into view; a hairline separates the
// blocks so the long form reads as clear steps. The last block has no line.
const FormSection = ({ isLast = false, children }) => (
  <Reveal
    y={18}
    className={isLast ? "tw:pt-6" : "tw:py-6 tw:border-b tw:border-[#EFEFEF] tw:first:pt-0"}
  >
    {children}
  </Reveal>
);

// Form <-> success page swap: the old view fades out before the new one rises in.
const viewSwap = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] } },
  exit: { opacity: 0, y: -8, transition: { duration: 0.2 } },
};

const CustomerRegisterPage = ({ alert }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.toUpperCase();
  const { showLoading, closeLoading } = useLoading();

  const formRefs = {
    emailRef: useRef(),
    passwordRef: useRef(),
    confirmPasswordRef: useRef(),
    businessNameRef: useRef(),
    businessPhoneNumberRef: useRef(),
    businessAddressRef: useRef(),
    businessIndustryRef: useRef(),
    businessTypeRef: useRef(),
    businessRegistrationNumberRef: useRef(),
    contactWebsite: useRef(),
    contactFirstNameRef: useRef(),
    contactLastNameRef: useRef(),
    contactPhoneNumberRef: useRef(),
    contactEmailRef: useRef(),
    billingPostalCodeRef: useRef(),
    billingCountryRef: useRef(),
    billingNameRef: useRef(),
    billingPhoneNumberRef: useRef(),
    billingAddressRef: useRef(),
    businessLicenseFileRef: useRef(null),
    agreeToTermsRef: useRef(),
  }

  const firstErrorRef = useRef(null);

  const [recipientErrors, setRecipientErrors] = useState([]);
  const [businessLicenseFile, setBusinessLicenseFile] = useState(null);
  const [isRegister, setisRegister] = useState(false);
  const [registeredId, setRegisteredId] = useState(null);
  const [profileData, setProfileData] = useState({
    //SECTION 1 - Account Informatino
    email: "",
    password: "",
    confirmPassword: "",

    //SECTION 2 - Business Information
    businessName: "",
    businessPrefixNumber: "+81",
    businessCountryCode: "JP",
    businessCountry: "Japan",
    businessPhoneNumber: "",
    businessAddress: "",
    businessLocInJapan: true,
    businessIndustry: "",
    businessType: "",
    businessRegistrationNumber: "",
    iataNumber: "",
    website: "",

    //SECTION 3 - Authorized Representative Contacts
    contactHonorifics: "Mr.",
    contactFirstName: "",
    contactLastName: "",
    contactPrefixNumber: "+81",
    contactCountryCode: "JP",
    contactCountry: "Japan",
    contactPhoneNumber: "",
    contactEmail: "",

    // SECTION 4 - Additional Email Recipients
    emailRecipients: [""],

    // SECTION 5 - Billing Information
    billingPostalCode: "",
    billingCity: "",
    billingName: "",
    billingPrefixNumber: "+81",
    billingCountryCode: "JP",
    billingCountry: "Japan",
    billingPhoneNumber: "",
    billingAddress: "",
    billingHonorifics: "Mr.",

    //SECTION 6 (Business License)
    license: null,
  });
  const [errorsProfileData, setErrorsProfileData] = useState({});
  const [isPostalCodeDisabled, setIsPostalCodeDisabled] = useState(false);
  const [isCityDisabled, setIsCityDisabled] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isJapanLoc, setIsJapanLoc] = useState(true);

  const addRecipient = () => {
    if (!profileData.emailRecipients.some((recipient) => !isValidEmail(recipient))) {
      setProfileData({
        ...profileData,
        emailRecipients: [
          ...profileData.emailRecipients,
          ""
        ]
      })
    }
  };

  const handleRecipientChange = (index, value) => {
    const updatedRecipients = [...profileData.emailRecipients];
    updatedRecipients[index] = value;
    setProfileData({
      ...profileData,
      emailRecipients: updatedRecipients
    });
  };

  const removeRecipient = (index) => {
    const updatedRecipients = [...profileData.emailRecipients];
    updatedRecipients.splice(index, 1);
    // setEmailRecipients(updatedRecipients);
    setProfileData({
      ...profileData,
      emailRecipients: updatedRecipients
    })
    // Hapus pesan kesalahan jika input dihapus
    setRecipientErrors(
      recipientErrors.filter((error) => error.index !== index)
    );
  };

  const handleButtonChooseFile = (event) => {
    formRefs.businessLicenseFileRef.current.click();
  };

  const handleChangeBusinessLicense = (event) => {
    const fileUploaded = event.target.files[0];
    if (!fileUploaded) return;

    setBusinessLicenseFile(fileUploaded);

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result;
      setProfileData({
        ...profileData,
        license: base64String
      })

      const currentValidation = errorsProfileData;
      delete currentValidation["license"];
      setErrorsProfileData(currentValidation);

    };
    reader.readAsDataURL(fileUploaded);
  };


  const handleFileSelect = (event) => {
    const selectedFile = event.target.files?.[0] || null

    if (selectedFile) {
      // Check file type
      const allowedTypes = ["application/pdf", "image/jpeg", "image/jpg"]
      const fileExtension = selectedFile.name.toLowerCase().split(".").pop()
      const allowedExtensions = ["pdf", "jpg", "jpeg"]

      if (!allowedTypes.includes(selectedFile.type) && !allowedExtensions.includes(fileExtension || "")) {
        alert.show("Please select only PDF, JPG, or JPEG files", { type: types.ERROR })
        return
      }

      const maxSizeInBytes = 5 * 1024 * 1024
      if (selectedFile.size > maxSizeInBytes) {
        alert.show("File size exceeds 5MB. Please select a smaller file.", { type: types.ERROR })
        return
      }

      setSelectedFile(selectedFile)

      // Create preview for images only
      if (selectedFile.type.startsWith("image/")) {
        const reader = new FileReader()
        reader.onload = (e) => {
          setPreview(e.target?.result)
        }
        reader.readAsDataURL(selectedFile)
      } else {
        setPreview(null)
      }
    } else {
      setSelectedFile(null)
      setPreview(null)
    }

    handleChangeBusinessLicense(event)
  }

  const handleRemoveBusinessLicense = () => {
    setSelectedFile(null)
    setPreview(null)
    if (formRefs.businessLicenseFileRef.current) {
      formRefs.businessLicenseFileRef.current.value = ""
    }

    setProfileData({
      ...profileData,
      license: null
    })
  }

  // Billing postal code: checked against the geocoding endpoint as the user
  // types. The hook reports the status (checking / found / failed …) that
  // BillingInformation shows; these callbacks update the form with the result.
  // Functional updates, so edits made to other fields during the check are kept.
  const postalCodeLookup = usePostalCodeLookup({
    postalCode: profileData.billingPostalCode,
    countryCode: profileData.billingCountryCode,
    // Countries without postal codes store "-" in a disabled field: nothing to check.
    isEnabled: !isPostalCodeDisabled,
    onFound: (city) => {
      setErrorsProfileData((previousErrors) => ({ ...previousErrors, billingPostalCode: null }));
      setProfileData((previousData) => ({ ...previousData, billingCity: city }));
    },
    onNotFound: () => {
      setErrorsProfileData((previousErrors) => ({
        ...previousErrors,
        billingPostalCode: "businessRegister.validation.billingPostalCodeInvalid",
      }));
      setProfileData((previousData) => ({ ...previousData, billingCity: "" }));
      formRefs.billingPostalCodeRef.current?.scrollIntoView({ block: "center" });
    },
  });

  useEffect(() => {
    if (!profileData.email) return;

    const handler = setTimeout(async () => {
      try {
        const checkEmail = await checkEmailRegister({ email: profileData.email });

        if (checkEmail.code !== 200 || checkEmail.desc !== "SUCCESS") {
          setErrorsProfileData(prev => ({
            ...prev,
            email: checkEmail.msg,
          }));
        }

      } catch (err) {
        console.error("Error checking email:", err);
      }
    }, 500); // debounce delay in ms

    return () => clearTimeout(handler); // cleanup on re-run
  }, [profileData.email]);

  const handleChangeProfile = (e) => {
    const { name, value } = e.target;
    if (name === "billingName" || name === "billingAddress") {
      const filteredValue = value.replace(/[^\w\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/g, "")
      setProfileData({
        ...profileData,
        [name]: filteredValue,
      });
    } else {
      setProfileData({
        ...profileData,
        [name]: value,
      });
    }

    const currentValidation = errorsProfileData;

    delete currentValidation[name];

    setErrorsProfileData(currentValidation);
  };

  const handleLiClickCountryList1 = (dialCode, countryCode, name) => {
    setProfileData({
      ...profileData,
      businessPrefixNumber: dialCode,
      businessCountryCode: countryCode,
      businessCountry: name,
    });
  };

  const handleLiClickCountryList2 = (dialCode, countryCode, name) => {
    setProfileData({
      ...profileData,
      contactPrefixNumber: dialCode,
      contactCountryCode: countryCode,
      contactCountry: name,
    });
  };

  const handleLiClickCountryList3 = (dialCode, countryCode, name) => {
    const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE;

    if (!countryWithoutPostCode.split(',').includes(countryCode)) {
      setIsPostalCodeDisabled(false);
      setIsCityDisabled(true);
      setProfileData({
        ...profileData,
        billingPostalCode: "",
        billingCity: "",
        billingPrefixNumber: dialCode,
        billingCountryCode: countryCode,
        billingCountry: name,
      })
    } else {
      setProfileData({
        ...profileData,
        billingPostalCode: "-",
        billingCity: "",
        billingPrefixNumber: dialCode,
        billingCountryCode: countryCode,
        billingCountry: name,
      })
      setIsPostalCodeDisabled(true);
      setIsCityDisabled(false);
    }
  };

  const validateProfileForm = async () => {
    const { validationSuccess, firstError, validationMessage } = await validateForm(profileData);

    firstErrorRef.current = null;
    if (!validationSuccess) {
      setErrorsProfileData({
        ...errorsProfileData,
        ...validationMessage
      });

      firstErrorRef.current = formRefs[firstError + "Ref"].current;

      if (firstErrorRef.current) {
        firstErrorRef.current.scrollIntoView({ block: "center" });
      }
    }

    if (errorsProfileData.email === "businessRegister.validation.emailInUse") {
      firstErrorRef.current = formRefs["email" + "Ref"].current;

      if (firstErrorRef.current) {
        firstErrorRef.current.scrollIntoView({ block: "center" });
      }

      return false
    }

    return validationSuccess;
  };

  const [showMoU, setShowMoU] = useState(false);

  const submitRegistration = async () => {
    setShowMoU(false);
    showLoading(true);
    const businessRegisterResponse = await businessRegister({
      name: profileData.businessName,
      email: profileData.email,
      password: profileData.password,
      confirmPassword: profileData.confirmPassword,
      businessInformation: {
        businessName: profileData.businessName,
        businessPrefixNumber: profileData.businessPrefixNumber,
        businessCountryCode: profileData.businessCountryCode,
        businessPhoneNumber: `${profileData.billingPhoneNumber}`,
        businessAddress: profileData.businessAddress,
        businessLocInJapan: profileData.businessLocInJapan,
        businessType: profileData.businessType,
        businessIndustry: profileData.businessIndustry,
        businessRegistrationNumber: profileData.businessRegistrationNumber,
        businessWebsite: profileData.website,
        businessIataNumber: profileData.iataNumber,
      },
      authorizedRepresentativeContact: {
        honorifics: profileData.contactHonorifics,
        firstName: profileData.contactFirstName,
        lastName: profileData.contactLastName,
        emailAddress: profileData.contactEmail,
        phoneNumber: profileData.contactPhoneNumber,
        countryCode: profileData.contactCountryCode,
        prefixNumber: profileData.contactPrefixNumber,
      },
      billingInformation: {
        name: profileData.billingName,
        prefix_number: profileData.billingPrefixNumber,
        country_code: profileData.billingCountryCode,
        country: profileData.billingCountry,
        phone: `${profileData.billingPhoneNumber}`,
        postal_code: profileData.billingPostalCode,
        city: profileData.billingCity,
        address: profileData.billingAddress,
        pronounced: profileData.billingHonorifics,
      },
      license: profileData.license,
      emailRecipients: profileData.emailRecipients,
      lang: lang
    });

    if (businessRegisterResponse.status === 200) {
      closeLoading(true);
      setisRegister(true);
      setRegisteredId(businessRegisterResponse.data.data.registeredId)
      window.scrollTo(0, 0);
    } else {
      closeLoading(true);
      alert.show(t("Registration failed"), { type: types.ERROR });
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validateForm = await validateProfileForm();

    if (validateForm) {
      setShowMoU(true);
    }
  };

  const resendEmailHandler = async () => {
    const resendEmail = await resendEmailAccountVerification({
      registeredId: registeredId,
    })

    if (resendEmail.status === 200) {
      alert.show("Resend Email Success", { type: types.SUCCESS });
    } else {
      alert.show(t("Re-send Email Failed"), { type: types.ERROR });
    }
  }

  return (
    <FrontLayout>
      <div className="tw:!bg-[#FFFFFF] tw:sm:!bg-[#F6F6F6]">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:mt-1 tw:pt-1">
          <div className="custom-mx">
            <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:pb-5 tw:mt-8">
              <div className="tw:!flex tw:!flex-wrap tw:!items-center">
                <AnimatePresence mode="wait" initial={false}>
                {!isRegister ? (
                  <motion.div
                    key="form"
                    className="tw:!w-full"
                    variants={viewSwap}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                  >
                    <div className="tw:flex tw:flex-wrap tw:justify-between">
                      <div className="tw:flex-1">
                        <Reveal
                          as="h2"
                          onMount
                          y={16}
                          className="tw:!font-libre-caslon-display tw:!text-[28px] tw:sm:!text-[32px] tw:!text-[#212529] tw:!font-normal tw:!mb-3"
                        >
                          {t("businessRegister.title")}
                        </Reveal>
                      </div>
                    </div>
                    <hr className="tw:block tw:sm:!hidden" />
                    <motion.div
                      className="tw:bg-white card-shadow-page tw:mt-3 tw:rounded-lg tw:!p-5 tw:sm:!p-8"
                      variants={fadeUp(24)}
                      initial="hidden"
                      animate="visible"
                    >
                      <FormSection>
                        <AccountInformation
                          containerClass=""
                          formRefs={formRefs}
                          profileData={profileData}
                          handleChangeProfile={handleChangeProfile}
                          errorsProfileData={errorsProfileData}
                        />
                      </FormSection>

                      <FormSection>
                        <BusinessInformation
                          containerClass=""
                          formRefs={formRefs}
                          profileData={profileData}
                          handleChangeProfile={handleChangeProfile}
                          errorsProfileData={errorsProfileData}
                          businessData={businessData}
                          businessTypeData={businessTypeData}
                          handleLiClickCountryList1={handleLiClickCountryList1}
                          setProfileData={setProfileData}
                          setErrorsProfileData={setErrorsProfileData}
                        />
                      </FormSection>

                      <FormSection>
                        <AuthorizedRepresentativeContacts
                          containerClass=""
                          formRefs={formRefs}
                          profileData={profileData}
                          handleChangeProfile={handleChangeProfile}
                          errorsProfileData={errorsProfileData}
                          optionsPronounce={optionsPronounce}
                          handleLiClickCountryList2={handleLiClickCountryList2}
                          setProfileData={setProfileData}
                          setErrorsProfileData={setErrorsProfileData}
                        />
                      </FormSection>

                      <FormSection>
                        <AdditionalEmail
                          containerClass=""
                          profileData={profileData}
                          handleRecipientChange={handleRecipientChange}
                          removeRecipient={removeRecipient}
                          addRecipient={addRecipient}
                        />
                      </FormSection>

                      <FormSection>
                        <BillingInformation
                          containerClass=""
                          formRefs={formRefs}
                          profileData={profileData}
                          handleChangeProfile={handleChangeProfile}
                          errorsProfileData={errorsProfileData}
                          optionsPronounce={optionsPronounce}
                          setProfileData={setProfileData}
                          handleLiClickCountryList3={handleLiClickCountryList3}
                          isPostalCodeDisabled={isPostalCodeDisabled}
                          postalCodeLookup={postalCodeLookup}
                          isCityDisabled={isCityDisabled}
                        />
                      </FormSection>

                      <FormSection isLast>
                        <BusinessLicense
                          containerClass=""
                          formRefs={formRefs}
                          errorsProfileData={errorsProfileData}
                          businessLicenseFile={businessLicenseFile}
                          handleButtonChooseFile={handleButtonChooseFile}
                          handleFileSelect={handleFileSelect}
                          handleRemoveBusinessLicense={handleRemoveBusinessLicense}
                          selectedFile={selectedFile}
                          preview={preview}
                        />
                      </FormSection>

                      <div className="tw:!grid tw:!place-items-center tw:!gap-2 tw:!w-full tw:!mx-auto tw:pt-4">
                        <motion.button
                          whileHover={pressable.hover}
                          whileTap={pressable.tap}
                          type="button"
                          className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:!flex tw:!items-center tw:!justify-center tw:!gap-1 tw:!w-full tw:md:!w-1/4 tw:!bg-[#DBBE78] tw:!text-[14px] tw:!text-[#FFFFFF] tw:!font-[700] tw:!rounded tw:!py-3"
                          disabled={false}
                          onClick={handleSubmit}
                        >
                          <span>{t("businessRegister.submitButton")}</span>
                          <ArrowRightIcon color="white" size={15} />
                        </motion.button>
                      </div>
                    </motion.div>
                  </motion.div>
                ) : (
                  <motion.div
                    key="success"
                    className="tw:!w-full"
                    variants={viewSwap}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                  >
                    <SuccessPage
                      profileData={profileData}
                      resendEmailHandler={resendEmailHandler}
                    />
                  </motion.div>
                )}
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MoUModal
        show={showMoU}
        handleClose={() => setShowMoU(false)}
        handleContinue={() => submitRegistration()}
      />
    </FrontLayout>
  );
};

export default withAlert()(CustomerRegisterPage);
